module.exports = __webpack_public_path__ + "img/turnTableBtn.e1a366db.png";